import { useTranslation } from 'react-i18next'

import { ReactComponent as Edit } from '../../../../assets/icons/pencil.svg'
import { ReactComponent as Delete } from '../../../../assets/icons/trash.svg'
import { IRegex, useLookupStore } from '../../../../stores/lookUpStore'

import styles from './regex-content.module.scss'

interface IRegexContentProps {
    regex: IRegex
    setIsEditing: React.Dispatch<React.SetStateAction<boolean>>
}

function RegexContent(props: IRegexContentProps) {
    const { regex, setIsEditing } = props
    const { _id, name, pattern } = regex

    const { t } = useTranslation()

    const [, { deleteRegex }] = useLookupStore()

    const handleDelete = () => {
        deleteRegex(_id)
    }

    return (
        <div className={styles.regexContent}>
            <div className={styles.regexContent__data}>
                <div className={styles.regexContent__nameSection}>{name}</div>
                <div className={styles.regexContent__patternSection}>
                    <div className={styles.regexContent__pattern}>
                        {pattern}
                    </div>
                    <div className={styles.regexContent__buttons}>
                        <button
                            className={styles.regexContent__btn}
                            onClick={() => setIsEditing(true)}
                        >
                            <Edit
                                alt={t('edit')}
                                className={styles.regexContent__icon}
                            />
                        </button>
                        <button
                            className={styles.regexContent__btn}
                            onClick={handleDelete}
                        >
                            <Delete
                                alt={t('delete')}
                                className={styles.regexContent__icon}
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RegexContent
